import { GridWithGaps } from '@dreamstack/feature-components/src/layout/MainGrid'
import { Css_Text_16_24_To_13_18_5_tw } from '@dreamstack/feature-components/src/layout/Texts'
import { useTranslation } from '@dreamstack/i18n'
import { clsxMerge, cn } from '@dreamstack/util'
import type { FunctionComponent } from 'react'

const CompanyFeaturesWrapper: FunctionComponent<
  React.PropsWithChildren<{}>
> = ({ children }) => (
  <GridWithGaps
    className={cn(
      'grid-cols-1 md:grid-rows-3 md:col-span-full md:grid-cols-12 text-accentroWhite-full gap-px-8!'
    )}
  >
    {children}
  </GridWithGaps>
)

const TileHeading: FunctionComponent<React.PropsWithChildren<{}>> = ({
  children,
}) => (
  <h3 className={cn('font-semibold text-px-24 leading-px-36')}>{children}</h3>
)

const TileBodyText: FunctionComponent<React.PropsWithChildren<{}>> = ({
  children,
}) => <p className={cn(Css_Text_16_24_To_13_18_5_tw)}>{children}</p>

type CompanyValueContentProps = React.PropsWithChildren<{ className?: string }>
const CompanyValueContent: FunctionComponent<CompanyValueContentProps> = ({
  children,
  className,
}) => (
  <div
    className={clsxMerge(
      'bg-accentroGray-full pt-px-24 px-px-32 pb-px-32 space-y-px-8 md:min-h-[226px] md:pt-px-32 md:px-px-40 lg:col-span-3',
      className
    )}
  >
    {children}
  </div>
)

export const CompanyFeatures = () => {
  const t = useTranslation()
  const PartnershipTitle = t('accentro:companyValuesTitle.partnership')
  const PartnershipValue = t('accentro:companyValues.partnership')
  const JoyTitle = t('accentro:companyValuesTitle.joy')
  const JoyValue = t('accentro:companyValues.joy')
  const ExpertiseTitle = t('accentro:companyValuesTitle.expertise')
  const ExpertiseValue = t('accentro:companyValues.expertise')
  const PassionTitle = t('accentro:companyValuesTitle.passion')
  const PassionValue = t('accentro:companyValues.passion')
  const TeamSpiritTitle = t('accentro:companyValuesTitle.teamSpirit')
  const TeamSpiritValue = t('accentro:companyValues.teamSpirit')
  const AdvancementTitle = t('accentro:companyValuesTitle.advancement')
  const AdvancementValue = t('accentro:companyValues.advancement')

  return (
    <CompanyFeaturesWrapper>
      <CompanyValueContent
        className={
          'w-[244px] md:col-span-6 md:w-auto lg:col-start-6 lg:col-span-3'
        }
      >
        <TileHeading>{PartnershipTitle}</TileHeading>
        <TileBodyText>{PartnershipValue}</TileBodyText>
      </CompanyValueContent>
      <CompanyValueContent
        className={'w-[291px] md:col-span-5 md:w-auto lg:col-span-2'}
      >
        <TileHeading>{JoyTitle}</TileHeading>
        <TileBodyText>{JoyValue}</TileBodyText>
      </CompanyValueContent>
      <CompanyValueContent
        className={
          'w-[273px] md:col-start-3 md:col-span-5 md:w-auto lg:col-start-2 lg:col-span-3'
        }
      >
        <TileHeading>{ExpertiseTitle}</TileHeading>
        <TileBodyText>{ExpertiseValue}</TileBodyText>
      </CompanyValueContent>
      <CompanyValueContent
        className={'w-[300px] md:col-span-5 md:w-auto lg:col-span-3'}
      >
        <TileHeading>{PassionTitle}</TileHeading>
        <TileBodyText>{PassionValue}</TileBodyText>
      </CompanyValueContent>
      <CompanyValueContent
        className={
          'w-[250px] md:col-start-1 md:col-span-5 md:w-auto lg:col-span-3'
        }
      >
        <TileHeading>{TeamSpiritTitle}</TileHeading>
        <TileBodyText>{TeamSpiritValue}</TileBodyText>
      </CompanyValueContent>
      <CompanyValueContent
        className={
          'w-[273px] md:col-span-5 md:w-auto lg:col-start-3 lg:col-span-3'
        }
      >
        <TileHeading>{AdvancementTitle}</TileHeading>
        <TileBodyText>{AdvancementValue}</TileBodyText>
      </CompanyValueContent>
    </CompanyFeaturesWrapper>
  )
}
